// Translation
import { useTranslationContext } from '../../../../context/TranslationContext';
// Components/ui
import { List, ListItemButton, ListItemIcon, ListItemText, useTheme } from '@mui/material';
// Icons
import { Person } from '@mui/icons-material';
import { UIEvent } from 'react';
import { IContact } from '@trii/types/dist/Contacts';

interface Props {
  handleScroll: (e: UIEvent<HTMLElement>) => void;
  contactList: IContact[];
  handleSelectContact: (contact: IContact) => void;
  selectedContactIds: string[];
  search: string;
}

const ContactSearchResults = ({
  handleScroll,
  contactList,
  handleSelectContact,
  selectedContactIds,
  search,
}: Props) => {
  const t = useTranslationContext();
  const theme = useTheme();

  return (
    <List
      sx={{
        width: '100%',
        height: '100%',
        overflow: 'auto',
        border: `1px solid ${theme.palette.divider}`,
        borderTop: 'none',
        //@ts-ignore
        backgroundColor: theme.palette.background.panel,
        backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.12))',
      }}
      onScroll={handleScroll}
    >
      {search &&
        contactList?.map((business) => (
          <ListItemButton
            key={business.id}
            sx={{
              width: '100%',
            }}
            onClick={() => handleSelectContact(business)}
            selected={selectedContactIds.includes(business.id)}
          >
            <ListItemIcon>
              <Person
                sx={{
                  color: (theme) => theme.palette.text.disabled,
                }}
              />
            </ListItemIcon>
            {/* @ts-ignore */}
            <ListItemText primary={t(business.name)} secondary={business?.phone} />
          </ListItemButton>
        ))}
    </List>
  );
};

export default ContactSearchResults;
